/** @format */

import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
/* REDUCERS */
import SessionReducer from './reducers/Session.reducer';
import NewDownloadReducer from './reducers/NewDownload.reducer';
import NewReportCompilerReducer from './reducers/NewReportCompiler.reducer';
import NewAggiornamentiReducer from './reducers/NewAggiornamenti.reducer';
/* EXTRA */

const preloadedState = loadFromSessionStorage();

const store = configureStore({
  reducer: {
    Session: SessionReducer,
    NewReportCompiler: NewReportCompilerReducer,
    NewDownload: NewDownloadReducer,
    NewAggiornamenti: NewAggiornamentiReducer
  },
  middleware: (getDefaultMiddleware) => {
    return process.env.REACT_APP_ENV === 'alm'
      ? getDefaultMiddleware().concat(logger)
      : getDefaultMiddleware();
  },
  devTools: process.env.REACT_APP_ENV === 'alm',
  preloadedState
});

store.subscribe(() => {
  saveToSessionStorage(store.getState());
});

export function saveToSessionStorage(state) {
  try {
    const serializedState = JSON.stringify(state);

    sessionStorage.setItem('reduxState', serializedState);
  } catch (e) {
  }
}

export function loadFromSessionStorage() {
  try {
    const serializedState = sessionStorage.getItem('reduxState');

    if (serializedState) {
      return JSON.parse(serializedState);
    } else {
      return undefined;
    }
  } catch (e) {

    return undefined;
  }
}

export default store;
